import { render, staticRenderFns } from "./BaseAddressInputs.vue?vue&type=template&id=6818fa45&"
import script from "./BaseAddressInputs.vue?vue&type=script&lang=ts&"
export * from "./BaseAddressInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports